module.exports = __webpack_public_path__ + "static/media/gt-america-standard-medium-italic.6f8d96ae.woff2";